/// <amd-module name="Wit/WorkItemForm/Attachments/FileDropZone" />
import * as React from "react";
import { useState } from "react";
import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";
import * as Resources from "Wit/WorkItemForm/Resources";

interface IFileDropZoneProps {
    onFilesDropped: (files: File[]) => void;
}

export function FileDropZone({ onFilesDropped, children }: React.PropsWithChildren<IFileDropZoneProps>) {
    const [active, setActive] = useState(false);

    return (
        <div
            className="file-drop-zone-container full-width full-height v-scroll-auto"
            onDragEnter={e => {
                if (!hasFiles(e)) {
                    return;
                }
                setActive(true);
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            {children}

            <div
                className={css("file-drop-zone-frame padding-16 absolute-fill", active && "active")}
                onDragLeave={e => {
                    setActive(false);
                }}
                onDrop={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setActive(false);
                }}
                onDragOver={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <div
                    className="file-drop-zone full-width full-height flex-column flex-center justify-center"
                    onDragOver={e => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onDrop={(e: React.DragEvent<unknown>) => {
                        setActive(false);

                        const files = extractFiles(e);
                        if (files.length === 0) {
                            return;
                        }

                        // Default behavior is to open files in the browser
                        e.preventDefault();

                        onFilesDropped(files);
                    }}
                >
                    <Icon className="file-drop-zone-icon font-size-xxxxl padding-bottom-16" iconName="Upload" />
                    <div className="file-drop-zone-header font-size-xl padding-bottom-16">{Resources.UploadFilesHeader}</div>
                    <div className="file-drop-zone-instructions font-size-ml padding-bottom-16">{Resources.UploadFilesInstructions}</div>
                </div>
            </div>
        </div>
    );
}

function hasFiles(e: React.DragEvent<unknown>): boolean {
    return extractFiles(e).length > 0;
}

function extractFiles(e: React.DragEvent<unknown>): File[] {
    if (e.dataTransfer?.items?.length > 0) {
        return Array.from(e.dataTransfer.items)
            .filter(item => item.kind === "file")
            .map(item => item.getAsFile() as File);
    }

    if (e.dataTransfer?.files?.length > 0) {
        return Array.from(e.dataTransfer.files);
    }

    return [];
}
